import { render, staticRenderFns } from "./ModelManager.vue?vue&type=template&id=fa57b212&scoped=true"
import script from "./ModelManager.vue?vue&type=script&lang=js"
export * from "./ModelManager.vue?vue&type=script&lang=js"
import style0 from "./ModelManager.vue?vue&type=style&index=0&id=fa57b212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa57b212",
  null
  
)

export default component.exports